require('./gapAccessStepOne.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
// @ utils
const { FormattedText } = require('core/i18n').i18n;
// @components
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');
const OKSelect = require('components/commons/OKSelect/OKSelect');
// @constants
const { GAPS_GAP, GAPS_CERTIFICADOS, GAPS_TRANSFERENCIA, GAPS_DALI } = require('constants/contactCenter/optionIdTracker');

class GapAccessStepOne extends React.Component {

    render() {
        const { operative, setOperative, daliOptionEnabled } = this.props;
        const gapLabel = <FormattedText value="gapAccess-gapLabel" />;
        const transferLabel = <FormattedText value="gapAccess-transferLabel" />;
        const certificateLabel = <FormattedText value="gapAccess-certificateLabel" />;
        const daliLabel = <FormattedText value="productBanner-daliLabel" />;
        const idNumberOptions = [
            { label: gapLabel, value: GAPS_GAP },
            { label: transferLabel, value: GAPS_TRANSFERENCIA },
            { label: certificateLabel, value: GAPS_CERTIFICADOS },
        ];
        if (daliOptionEnabled) idNumberOptions.push({ label: daliLabel, value: GAPS_DALI });
        const stepTitle = <FormattedText value="gapAccess-stepOneTitle" />;
        const stepOnePrompt = <FormattedText value="gapAccess-stepOnePrompt" />;

        return (
            <section className="step-container">
                <div className="gap-access-step1">
                    <div className="gap-access-step1__header">
                        <h4 className="wizard-step--vertical__title">
                            {stepTitle}
                        </h4>
                    </div>

                    <div className="gap-access-step1__content">
                        <div className="col-xs-6">
                            <BlockInfo>
                                <p>
                                    {stepOnePrompt}
                                </p>
                            </BlockInfo>
                        </div>
                        <div className="col-xs-6">
                            <div className="gap-access-step1__select-wrap">
                                <OKSelect
                                    name="idDocument"
                                    options={idNumberOptions}
                                    value={operative}
                                    onChange={setOperative}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

GapAccessStepOne.propTypes = {
    operative: PropTypes.object.isRequired,
    setOperative: PropTypes.func.isRequired,
    daliOptionEnabled: PropTypes.bool.isRequired,
};

module.exports = GapAccessStepOne;
